import type { ReactNode } from 'react';
import { cx } from './cx';

export interface FieldProps {
  label: ReactNode;
  htmlFor?: string;
  hint?: ReactNode;
  error?: ReactNode;
  children: ReactNode;
  className?: string;
  /**
   * Optional stable id used by the Settings search bar to deep-link to a
   * specific field. The id renders on a wrapping `<div>` so the
   * `useScrollAnchorHighlight` hook can call `el.scrollIntoView({ block:
   * 'center' })` and apply the brief flash style.
   *
   * Use the same string the searchIndex.ts entry stores under `hash`
   * (without the leading `#`).
   */
  anchorId?: string;
}

export function Field({
  label,
  htmlFor,
  hint,
  error,
  children,
  className,
  anchorId,
}: FieldProps) {
  return (
    <div
      id={anchorId}
      data-settings-anchor={anchorId ? '' : undefined}
      className={cx('flex flex-col gap-1.5', className)}
    >
      <label htmlFor={htmlFor} className="smallcap">
        {label}
      </label>
      {children}
      {hint && !error ? <p className="text-xs text-muted">{hint}</p> : null}
      {error ? <p className="text-xs text-clay">{error}</p> : null}
    </div>
  );
}
